import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import HomePage from './pages/HomePage'
import MilitaryCalculatorPage from './pages/MilitaryCalculatorPage'
import GeorgiaCalculatorPage from './pages/GeorgiaCalculatorPage'
import VirginiaCalculatorPage from './pages/VirginiaCalculatorPage'
import CaliforniaCalculatorPage from './pages/CaliforniaCalculatorPage'
import WashingtonCalculatorPage from './pages/WashingtonCalculatorPage'

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50 flex flex-col">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/military-calculator" element={<MilitaryCalculatorPage />} />
            <Route path="/georgia-payroll-calculator" element={<GeorgiaCalculatorPage />} />
            <Route path="/virginia-pay-calculator" element={<VirginiaCalculatorPage />} />
            <Route path="/california-paycheck-calculator" element={<CaliforniaCalculatorPage />} />
            <Route path="/washington-salary-calculator" element={<WashingtonCalculatorPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

export default App
